<template>
  <v-menu v-if="editable" :model-value="menuOpen" location="bottom" :close-on-content-click="false" @update:model-value="onMenuToggle">
    <template #activator="{ props: menuProps }">
      <button v-bind="menuProps" type="button" class="no-plan group" title="Create an allocation for this week">
        <span class="italic">No plan</span>
        <span class="no-plan__action font-semibold text-blue-600 opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100" aria-hidden="true">+ add</span>
      </button>
    </template>
    <!-- The type row is too short to hold the menu inline the way the Capacity Calendar's cell
         does, so the same menu opens in a popover under the cell instead. -->
    <div class="no-plan__popover">
      <NoPlanCellMenu :unit="unit" :previous-week-plan="previousWeekPlan" @copy="emit('copy')" @add="(capacity) => emit('add', capacity)" @close="emit('close')" />
    </div>
  </v-menu>
  <p v-else class="no-plan no-plan--static">
    <span class="italic">No plan</span>
  </p>
</template>

<script setup lang="ts">
  import NoPlanCellMenu from '@/components/capacity/NoPlanCellMenu.vue';
  import type { PreviousWeekPlan } from '@/utils/previousWeek';

  defineProps<{
    // Whether clicking does anything: write:capacity only. Otherwise the cell is display-only.
    editable: boolean;
    // Externally controlled — the view owns which cell's menu is open (see useNoPlanMenu).
    menuOpen: boolean;
    unit: string | null;
    // Only meaningful while menuOpen; null hides the copy line.
    previousWeekPlan: PreviousWeekPlan | null;
  }>();

  const emit = defineEmits<{
    open: [];
    close: [];
    copy: [];
    add: [capacity: number];
  }>();

  function onMenuToggle(open: boolean): void {
    if (open) emit('open');
    else emit('close');
  }
</script>

<style scoped>
  .no-plan {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: rgb(209 213 219);
    font-size: 11px;
  }

  .no-plan--static {
    cursor: default;
  }

  .no-plan__action {
    transition: opacity 120ms ease;
  }

  .no-plan__popover {
    width: 15rem;
    border: 1px solid rgb(226 232 240);
    border-radius: 0.5rem;
    background: white;
    box-shadow: 0 8px 24px rgb(15 23 42 / 12%);
  }
</style>
